<template>
  <div class="range-time-box">
    <el-date-picker
     
      @change="searchChange"
      v-model="state.data"
      type="datetimerange"
      :default-time="[
        new Date(2000, 1, 1, 0, 0, 0),
        new Date(2000, 1, 1, 23, 59, 59),
      ]"
      style="width: 290px"
      :shortcuts="shortcuts"
      :start-placeholder="$attrs.startPlaceholder"
      :end-placeholder="$attrs.endPlaceholder"
      align="right"
      range-separator="-"
    />
  </div>
</template>

<script lang="ts">
import { CaretBottom, CaretTop, DataLine } from "@element-plus/icons-vue";
import isArray from "lodash-es/isArray";
import { defineComponent, onMounted, onBeforeMount, reactive, watch, onUnmounted } from "vue";
import type { ComponentPublicInstance, ExtractPropTypes, PropType, SetupContext, StyleValue, VNode } from "vue";
import type { stateData, Value, RadioChilder, RadioGather, RadioGatherType } from "./types";
import $, { post } from "jquery";
import { buildProps } from "../../utils/props";

import { cloneDeep, times } from "lodash-es";
import moment from "moment";
import { $t } from "@user-center/utils/i18n.ts";
import isEqual from "lodash-es/isEqual";
const NumberRangeProps = buildProps({
  modelValue: {
    type: Object,
    default: () => ({}),
  },
});
type NumberRangePropsType = ExtractPropTypes<typeof NumberRangeProps>;
export default defineComponent({
  // emits: ["update:modelValue"],
  name: "rangeTime",
  props: NumberRangeProps,
  setup(props: NumberRangePropsType, ctx: SetupContext<any>) {
    var state: any = reactive({
      data: [],
      comparativeData: {},
    });
    let antiShake: any = undefined;
    const shortcuts = [
      {
        text:  $t("placeholder.今天"),
        value: () => {
          const end = new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 -
              1
          );
          const start = new Date(
            new Date(new Date().toLocaleDateString()).getTime()
          );
          return [start, end];
        },
      },
      {
        text:  $t("text.near3Day"),
        value: () => {
          const end = new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 -
              1
          );
          const start = new Date(
            new Date(new Date().toLocaleDateString()).getTime()
          );
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
          return [start, end];
        },
      },
      {
        text:$t("text.near1Week"), 
        value: () => {
          const end = new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 -
              1
          );
          const start = new Date(
            new Date(new Date().toLocaleDateString()).getTime()
          );
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
          return [start, end];
        },
      },
    ];
    // 搜索值的改变
    function searchChange() {
      if (antiShake) clearTimeout(antiShake);
      antiShake = setTimeout(async () => {
        let start =
          state.data && state.data[0]
            ? moment(state.data[0]).format("YYYY-MM-DD") + " 00:00:00"
            : null;
        let end =
          state.data && state.data[0]
            ? moment(state.data[1]).format("YYYY-MM-DD") + " 23:59:59"
            : null;
        state.comparativeData = { start, end };
        ctx.emit("update:modelValue", { ...state.comparativeData });
      }, 500);
    }
    watch(
      () => props.modelValue,
      (v: any) => {
        if (!isEqual(v, state.comparativeData)) {
          state.comparativeData = {};
          if (v && v.start && v.end) {
            state.data = [v.start, v.end];
          } else {
            state.data = [];
          }
        }
      },
      { deep: true, immediate: true }
    );
    return {
      shortcuts,
      searchChange,
      props,
      state,
    };
  },
});
</script>

<style lang="scss" scoped>
:deep( .el-date-editor ) {
  width: auto !important;
}
</style>
